import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Item from './Item'

export default class List extends Component {
  render() {
    var topics = this.props.topics.map(function (topic, index) {
      return (
        <Item
          topic={topic}
          key={index}
          deleteTopic={this.props.deleteTopic}
          changeContext={this.props.changeContext}
          lines={3}
          dispatch={this.props.dispatch}
          hideActions={this.props.hideActions}
        />
      )
    }, this)

    return (
      <ul
        style={{
          float: 'left',
          width: '100%',
          padding: '0 0 20px'
        }}
      >
        {topics}
      </ul>
    )
  }
}

List.propTypes = {
  topics: PropTypes.array.isRequired,
  deleteTopic: PropTypes.func.isRequired,
  changeContext: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  hideActions: PropTypes.bool.isRequired,
  lines: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/topics/List.js